import React from 'react';
import PropTypes from 'prop-types';
import logo from '../assets/logos/large.webp';
import logoFallback from '../assets/logos/large.png';
import chindoguPng from '../assets/logos/chindogu.png';
import chindoguWebp from '../assets/logos/chindogu.webp';
import jugaadPng from '../assets/logos/jugaad.png';
import jugaadWebp from '../assets/logos/jugaad.webp';

const Logo = ({ mode }) => {
	let image = logo;
	let fallback = logoFallback;

	if (mode === 'chindogu') {
		image = chindoguWebp;
		fallback = chindoguPng;
	} else if (mode === 'jugaad') {
		image = jugaadWebp;
		fallback = jugaadPng;
	}
	return (
		<picture>
			<source srcSet={image} />
			<img srcSet={fallback} alt="Logo" id="large_logo" />
		</picture>
	);
};

export default Logo;

Logo.propTypes = {
	mode: PropTypes.string,
};

Logo.defaultProps = {
	mode: undefined,
};
